import { useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';

import { SingleTableBoxScene, CustomTabPanel } from '@/shared/components/ui';

import { MfaAdminUsuariosTab } from './components/MfaAdminUsuariosTab';
import { MfaAdminMetricasTab } from './components/MfaAdminMetricasTab';
import { MfaAdminPoliticaTab } from './components/MfaAdminPoliticaTab';
import { MfaAdminBitacoraTab } from './components/MfaAdminBitacoraTab';

const MfaAdminPage = () => {
  const [tab, setTab] = useState(0);

  return (
    <SingleTableBoxScene title="Administración de Doble Factor (MFA)">
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
        <Tabs value={tab} onChange={(_, v) => setTab(v)}>
          <Tab label="Usuarios" />
          <Tab label="Métricas" />
          <Tab label="Política" />
          <Tab label="Bitácora" />
        </Tabs>
      </Box>

      <CustomTabPanel value={tab} index={0}>
        <MfaAdminUsuariosTab />
      </CustomTabPanel>
      <CustomTabPanel value={tab} index={1}>
        <MfaAdminMetricasTab />
      </CustomTabPanel>
      <CustomTabPanel value={tab} index={2}>
        <MfaAdminPoliticaTab />
      </CustomTabPanel>
      <CustomTabPanel value={tab} index={3}>
        <MfaAdminBitacoraTab />
      </CustomTabPanel>
    </SingleTableBoxScene>
  );
};

export default MfaAdminPage;
